export class LeadIdInput {
  leadId: string;
}
